module.exports = __webpack_public_path__ + "static/img/a126.cc14f9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a126.jpg
// module id = MWFg
// module chunks = 0